import authInstance from 'config/axios.config';

export const serviceCatalogServices = {
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await authInstance.post('/admin/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  },

  getServiceCatalog: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== 'all') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/admin/service-catalog?${params}`);
    return res.data;
  },

  getServiceCatalogById: async (id) => {
    const res = await authInstance.get(`/admin/service-catalog/${id}`);
    return res.data;
  },

  addServiceCatalog: async (payload) => {
    const res = await authInstance.post('/admin/service-catalog', payload);
    return res.data;
  },

  updateServiceCatalog: async ({ id, data }) => {
    const res = await authInstance.put(`/admin/service-catalog/${id}`, data);
    return res.data;
  },

  toggleStatus: async (id) => {
    const res = await authInstance.patch(`/admin/service-catalog/${id}/toggle-status`);
    return res.data;
  },

  softDeleteServiceCatalog: async (id) => {
    const res = await authInstance.delete(`/admin/service-catalog/${id}`);
    return res.data;
  },

  hardDeleteServiceCatalog: async (id) => {
    const res = await authInstance.delete(`/admin/service-catalog/${id}/hard-delete`);
    return res.data;
  },
};
